import { RecaptchaVerifier } from "firebase/auth";
import { auth } from "../config/config-firebase";

function wipeContainer(containerId) {
  const el = document.getElementById(containerId);
  if (el) {
    el.innerHTML = "";
  }
}

export function clearRecaptchaVerifier(containerId = "recaptcha-container") {
  if (window.recaptchaVerifier) {
    try {
      if (typeof window.recaptchaVerifier.clear === "function") {
        window.recaptchaVerifier.clear();
      }
    } catch (err) {
      console.error("clearRecaptchaVerifier:", err);
    }
    delete window.recaptchaVerifier;
  }
  wipeContainer(containerId);
}

export function getRecaptchaVerifier(containerId, { force = false } = {}) {
  if (!force && window.recaptchaVerifier) {
    return window.recaptchaVerifier;
  }

  clearRecaptchaVerifier(containerId);

  const container = document.getElementById(containerId);
  if (!container) {
    throw new Error(`Recaptcha container not found: ${containerId}`);
  }

  const verifier = new RecaptchaVerifier(auth, container, {
    size: "invisible",
    callback: () => {},
  });

  window.recaptchaVerifier = verifier;
  return verifier;
}
